/* eslint-disable */
import Vue from "vue"
import Router from "vue-router"
import store from "./store"

import axios from 'axios'
import range from 'lodash.range'

const apiBase = API_APP_PATH + "/v1"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/",
      component: () => import("@/App"),
      async beforeEnter(to, from, next) {

        const user = await store.dispatch("userInit")

        if (user.length === 0) {
          next()
        } else {
          if (user.role === "Teacher") {

            store.dispatch("teacher/teacherInit").then(success => {
              next()
            })

          } else {

            store.dispatch("admin/fetchSchools").then(success => {
              next()
            })

          }
        }
      },
      children: [
        {
          name: "home",
          path: "",
          component: () => import("@/views/Layout.vue")
        },
        {
          name: "dashboard",
          path: "dashboard",
          beforeEnter: (to, from, next) => {
            if (store.state.role === "Teacher") {
              next()
            } else {
              let selectedSchool = store.getters["admin/getSelectedSchool"];
              if (!selectedSchool.dbn) {
                next("/")
              } else {
                next()
              }
            }
          },
          component: () =>
            store.getters.getUserRole !== "Teacher"
              ? import("@/components/admin/Dashboard.vue")
              : import("@/components/teacher/Dashboard.vue")
        },
        {
          name: 'school-dashboard',
          path: 'school-dashboard',
          beforeEnter: (to, from, next) => {
            if (['Teacher', 'Principal', 'Assistant Principal', 'School Based Staff'].indexOf(store.state.role) === -1) {
              next()
            } else {
              next(false)
            }
          },
          component: () => import("@/components/admin/Dashboard.vue")
        },
        {
          name: "caseload",
          path: "caseload",
          beforeEnter: (to, from, next) => {
            if (store.state.role === "Teacher") {
              next(false);
            } else {
              let selectedSchool = store.getters["admin/getSelectedSchool"];
              if (!selectedSchool.dbn) {
                next("/");
              } else {
                next();
              }
            }
          },
          component: () => import("@/components/admin/CaseloadManager.vue")
        },
        {
          name: "teacher-dashboard",
          path: "dashboard/:id",
          beforeEnter: (to, from, next) => {
            store.state.role !== "Teacher" ? next() : next(false);
          },
          component: () =>
            import("@/components/admin/TeacherDashboardContainer.vue")
        },
        {
          name: "observations",
          path: "observations/:id",
          beforeEnter: (to, from, next) => {
            store.state.role !== "Teacher" ? next() : next(false)
          },
          component: () =>
            import("@/components/admin/ObservationsContainer.vue")
        },
        {
          name: "teacher-observations",
          path: "observations",
          beforeEnter: (to, from, next) => {
            store.state.role === "Teacher" ? next() : next(false)
          },
          component: () => import("@/components/admin/ObservationsContainer.vue")
        },
        {
          name: "reflections",
          path: "reflections",
          component: () => import("@/views/Reflections.vue")
        },
        {
          name: "weteach",
          path: "weteachnyc",
          component: () => import("@/views/WeTeach.vue")
        },
        {
          name: "goalSetting",
          path: "goalSetting",
          component: () => import("@/views/Notecatcher.vue"),
          children: [
            {
              name: "admin",
              path: "admin",
              component: () => import("@/views/NCAdminLanding.vue")
            },
            {
              name: "adminresponses",
              path: "adminresponses/:formid/",
              component: () => import("@/views/NCAdminResponses.vue")
            },
            {
              name: "teacher",
              path: "teacher",
              component: () => import("@/views/NCTeacherLanding.vue")
            },
            {
              name: "goalsettingform",
              path: "goalsettingform/:formid/",
              component: () =>
                import("@/components/notecatcher/teachers/CompletedForm.vue")
            },
            {
              name: "newgoalsettingform",
              path: "goalsettingform/new/:formid/",
              component: () =>
                import("@/components/notecatcher/teachers/ActiveForm.vue")
            }
          ]
        },
        {
          name: "goals",
          path: "goals",
          component: () => import("@/views/GoalsContainer.vue"),
          beforeEnter: (to, from, next) => {
            if (
              store.state.journalAccess ||
              store.getters["teacher/getJournalAccess"]
            ) {
              store
                .dispatch("teacher/getGoals", store.state.employeeId)
                .then(success => {
                  next();
                })
                .catch(error => {
                  next();
                });
            } else {
              next("/");
            }
          }
        },
        {
          name: "notes",
          path: "notes",
          component: () => import("@/views/NotesContainer.vue"),
          beforeEnter: (to, from, next) => {
            if (
              store.state.journalAccess ||
              store.getters["teacher/getJournalAccess"]
            ) {
              store
                .dispatch("teacher/getNotes", store.state.employeeId)
                .then(success => {
                  next();
                })
                .catch(error => {
                  next();
                });
            } else {
              next("/");
            }
          }
        },
        {
          name: 'district-dashboard',
          path: 'district-dashboard',
           beforeEnter: async(to, from, next) => {
            if (from.name === null) {

              if (store.state.role !== 'Principal') {
                // TODO: update logic here since central user have been added to Districts view in SQL
                if (store.getters.getUserRole === 'Central') {
                  let districts = range(1, 33).map(x => x < 10 ? `0${x}` : x.toString())
                  // adding D75,D79
                  districts.push('75','79')
                  store.commit('admin/updateDistrictsList', districts.map(x => ({District: x})))
                } else {
                  const id = store.state.employeeId
                  const { data: schools } = await axios.get(`${apiBase}/data/admin/app/ge/schools/${id}`)
                  store.commit('admin/updateDistrictSchools', schools)
                  const { data: districts } = await axios.get(`${apiBase}/data/admin/app/ge/districts/${id}`)
                  store.commit('admin/updateDistrictsList', districts)
                }
              }
            }
            next()
          },
          component: () => import('@/components/admin/BCODashboard.vue')
        }
      ]
    }
  ]
});

export default router;
